export default __webpack_public_path__ + "static/media/product-2.2a9a22ff.jpg";